import React, { CSSProperties, DetailedHTMLProps, FC, HTMLAttributes, useState, useEffect } from "react";
import { ClassNames } from "../../modules/utils";
import styles from "./index.module.scss";

export interface IBoxProps {
  title: any;
  description?: any;
  style?: CSSProperties;
  className?: string;
  headClassName?: string;
  titleRight?: any;
  onTitleClick?: () => void;
  contentProps?: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
  collapsible?: boolean;
  defaultCollapsed?: boolean;
  onCollapseChange?: (collapsed: boolean) => void;
}

export const Box: FC<IBoxProps> = (props) => {
  const [isCollapsed, setIsCollapsed] = useState(props.defaultCollapsed ?? false);

  useEffect(() => {
    if (props.defaultCollapsed !== undefined) {
      setIsCollapsed(props.defaultCollapsed);
    }
  }, [props.defaultCollapsed]);

  const handleToggleCollapse = () => {
    if (!props.collapsible) return;
    const newCollapsed = !isCollapsed;
    setIsCollapsed(newCollapsed);
    props.onCollapseChange?.(newCollapsed);
  };

  return (
    <div
      style={props.style}
      className={ClassNames({ [styles.Box]: true, [props.className as string]: !!props.className })}
    >
      <div className={ClassNames({ [styles.head]: true, [props.headClassName as string]: !!props.headClassName })}>
        <div className={styles.title} onClick={props.onTitleClick ? props.onTitleClick : () => {}}>
          {props.collapsible && (
            <span
              className={styles.collapseIcon}
              onClick={(e) => {
                e.stopPropagation();
                handleToggleCollapse();
              }}
              style={{
                transform: isCollapsed ? "rotate(-90deg)" : "rotate(0deg)",
              }}
            >
              ▼
            </span>
          )}
          {props.title}
        </div>
        {props.titleRight}
      </div>
      {!isCollapsed && props.description ? <div className={styles.description}>{props.description}</div> : null}
      {!isCollapsed && (
        <div className={styles.content} {...props.contentProps}>
          {props.children}
        </div>
      )}
    </div>
  );
};
